import React from 'react'

import DefaultPersonalInfo from './Default'
import { enhance } from './enhance'
import SpendPersonalInfo from './Spend'

type Props = {
  flow: string
}

export const PersonalInfo: React.SFC<Props> = ({ flow }) => {
  return flow.toLowerCase() === 'spend' ? <SpendPersonalInfo /> : <DefaultPersonalInfo />
}

export default enhance(PersonalInfo)
